import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { AccelerationRecommendations } from '~src/dataAcceleration/resources/AccelerationRecommendations';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { ContentTypeFilterClause, ExplorableItemDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { PerformanceContentType } from '~src/spacesPlatform/models/ContentTypes';

import { getGenericDefaultFilters } from '../../spacesPlatform/contentDefinitions/getDefaultFilters';

export const PerformanceDefinition: ExplorableItemDefinition = {
  itemType: 'performance',
  pluralName: Messages.performance,
  singularName: Messages.performance,
  emptyStateMessage: Messages.emptyAccelerationRecommendations,
  contentFilterKeys: PerformanceContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconType: null,
  filterClause: ServerFilterClauses.ContentType(['performance']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return AccelerationRecommendations.all().withExtraParams(PerformanceContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list']
};
